module.exports = __webpack_public_path__ + "img/SES_220411240.8ff803da.jpg";